import React from 'react';

const PackProductSection = ({ packs, setPacks }) => {
  const addPack = () => {
    setPacks(prev => [...prev, { qte: '', prixUnitaireTTC: '' }]);
  };

  const removePack = (index) => {
    setPacks(prev => prev.filter((_, i) => i !== index));
  };

  const updatePack = (index, field, value) => {
    setPacks(prev => prev.map((pack, i) => i === index ? { ...pack, [field]: value } : pack));
  };

  return (
    <div className="sm:col-span-6">
      <div className="relative flex items-start bg-gray-50 p-4 rounded-md border border-gray-200">
        <div className="w-full">
          <div className="flex items-center justify-between mb-3">
            <div>
              <h3 className="text-sm font-medium text-gray-700">Offres Pack (optionnel)</h3>
              <p className="text-xs text-gray-500 mt-0.5">
                Définissez des prix réduits pour l'achat en quantité
              </p>
            </div>
            <button
              type="button"
              onClick={addPack}
              className="inline-flex items-center px-3 py-1.5 border border-[#174540] text-xs font-medium rounded-md text-[#174540] bg-white hover:bg-[#174540] hover:text-white transition-colors"
            >
              <svg className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
              </svg>
              Ajouter un pack
            </button>
          </div>

          {packs.length > 0 && (
            <div className="space-y-3">
              {packs.map((pack, index) => (
                <div key={index} className="flex items-center gap-3 bg-white p-3 rounded-md border border-gray-200">
                  <div className="flex-1">
                    <label className="block text-xs font-medium text-gray-600 mb-1">Quantité</label>
                    <input
                      type="number"
                      min="2"
                      step="1"
                      value={pack.qte}
                      onChange={(e) => updatePack(index, 'qte', e.target.value)}
                      placeholder="Ex: 2"
                      className="block w-full py-2 px-3 text-sm border border-gray-300 rounded-md focus:ring-[#174540] focus:border-[#174540]"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-xs font-medium text-gray-600 mb-1">Prix unitaire TTC (DT)</label>
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={pack.prixUnitaireTTC}
                      onChange={(e) => updatePack(index, 'prixUnitaireTTC', e.target.value)}
                      placeholder="Ex: 30.00"
                      className="block w-full py-2 px-3 text-sm border border-gray-300 rounded-md focus:ring-[#174540] focus:border-[#174540]"
                    />
                  </div>
                  <div className="flex-shrink-0">
                    <label className="block text-xs font-medium text-gray-600 mb-1">Total</label>
                    <span className="block py-2 px-3 text-sm font-medium text-gray-700 bg-gray-50 rounded-md border border-gray-200 min-w-[80px] text-center">
                      {pack.qte && pack.prixUnitaireTTC
                        ? `${(parseFloat(pack.qte) * parseFloat(pack.prixUnitaireTTC)).toFixed(2)} DT`
                        : '—'}
                    </span>
                  </div>
                  <div className="flex-shrink-0 pt-5">
                    <button
                      type="button"
                      onClick={() => removePack(index)}
                      className="p-1.5 text-red-400 hover:text-red-600 hover:bg-red-50 rounded-md transition-colors"
                      title="Supprimer ce pack"
                    >
                      <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {packs.length === 0 && (
            <p className="text-xs text-gray-400 italic">Aucun pack configuré. Le produit sera vendu à l'unité uniquement.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PackProductSection;
